import React from 'react';
import './GameControls.css';

export type PracticeMode = 'single-notes' | 'triads';

interface GameControlsProps {
  isGameActive: boolean;
  onStartSingleNotes: () => void;
  onStartTriads: () => void;
  onStopGame: () => void;
}

const GameControls: React.FC<GameControlsProps> = ({ 
  isGameActive, 
  onStartSingleNotes,
  onStartTriads,
  onStopGame 
}) => {
  return (
    <div className="game-controls">
      {!isGameActive ? (
        <div className="mode-buttons">
          <button 
            className="control-button start-button"
            onClick={onStartSingleNotes}
          >
            Practice Single Notes
          </button>
          <button 
            className="control-button start-button"
            onClick={onStartTriads}
          >
            Practice Triads
          </button>
        </div>
      ) : (
        <button 
          className="control-button stop-button"
          onClick={onStopGame}
        >
          Stop Practice
        </button>
      )}
    </div>
  );
};

export default GameControls;